import CookieBannerView from 'components/utility/CookieBanner/components/CookieBannerView/CookieBannerView';
import useCookieBannerViewModel from 'components/utility/CookieBanner/hooks/useCookieBannerViewModel';
import React from 'react';

const CookieBanner = () => {
  const { isVisible, viewProps } = useCookieBannerViewModel();
  if (!isVisible) return null;

  return <CookieBannerView {...viewProps} />;
};

export default CookieBanner;
